import React from 'react';
import { VLink } from "../AppDataContext";
import { urlEncodeText } from '../../helpers';

export function AuctionTile(props) {
    const secondsToClose = props.auction.secondsToClose;
    const days = Math.floor(secondsToClose / (60 * 60 * 24));
    const hours = Math.floor((secondsToClose - (days * 24 * 60 * 60)) / (60 * 60));
    const minutes = Math.floor((secondsToClose - (days * 24 * 60 * 60) - (hours * 60 * 60)) / (60));

    const auctionUrl = '/auction/' + props.auction.secureId + '/' + urlEncodeText(props.auction.title);
    const auctionImageUrl = '/api/site/auctionphoto/' + props.auction.secureId + "/450";

    return (
      
        <div class="col-6 col-md-4 mb-4">
            <div class="auction--item auction--item__auction">  
                <div class="auction--item__image auction--item__auction--img position-relative" >
                    { /*
                    <span class="position-absolute auction-labels">
                        <label class="me-1 mb-1 auction-label featured">Featured</label>
                    </span>
                    */ }
                    <VLink to={auctionUrl} style={{ textDecoration: 'none', backgroundImage: "url(" + auctionImageUrl + ")" }}>
                        
                    </VLink>
                </div>
                <div class="auction--item__content pt-1">
                    <div class="auction--item__content--details px-3 pb-2">
                        <h3>
                            <VLink to={auctionUrl} style={{ textDecoration: 'none' }} >
                                {props.auction.title}
                            </VLink>
                        </h3>
                        <div class="d-none d-md-flex auction-info__item mb-1">
                            <i class="bi bi-clock d-inline-block me-1"></i>
                            <div class="d-inline-block">
                                {props.auction.closeTimeLocalStr}
                            </div>
                        
                        </div>
                        <div class="d-none d-md-flex auction-info__item mb-1">
                            <i class="bi bi-geo-alt d-inline-block me-1"></i>
                            <div class="d-inline-block">
                                {props.auction.auction.city}, {props.auction.auction.state}
                            </div>
                        </div>
                        <div class="d-none d-md-flex auction-info__item mb-1">
                            <i class="bi bi-tags d-inline-block me-1"></i>
                            <div class="d-inline-block">
                                {props.auction.lotCount} Lot{props.auction.lotCount != 1 ? "s" : ""}
                            </div>
                        </div>
                        {props.showSeller != false &&
                            <div class="auction-info__item mb-1 text-center">
                                <VLink to={'/Seller/' + props.auction.auction.companySecureId} title={props.auction.auction.companyName} class="auction-info__item--auctionedby"><span class="d-none d-md-inline-block">Auctioned by {props.auction.auction.companyName}</span> <img src={"api/site/SellerLogo/" + props.auction.auction.companySecureId} alt={props.auction.auction.companyName} title={props.auction.auction.companyName} /> </VLink>
                            </div>
                        }
                    </div>
                    <div class="auction--item__content--actions">
                        <div class="row py-2 px-0 m-0">
                            <div class="col text-center counter">
                                {secondsToClose > 60 ?
                                    <>
                                        {days > 0 && <span>{days}d </span>}
                                        {(days > 0 || hours > 0) && <span>{hours}h </span>}
                                        <span>{minutes}m </span>
                                    </>
                                    :
                                    props.auction.live ?
                                        <span>Happening Now</span>
                                        :
                                        <span>Closed</span>

                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    );
}
